"use client";

import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";

import { cn } from "lib/utils";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn("tw-border-b", className)}
    {...props}
  />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef(
  ({ className, children, variant = "default", ...props }, ref) => (
    <AccordionPrimitive.Header className="tw-flex">
      <AccordionPrimitive.Trigger
        ref={ref}
        className={cn(
          "tw-flex tw-flex-1 tw-items-center tw-justify-between tw-py-4 tw-text-base tw-font-medium tw-transition-colors hover:tw-text-primary tw-text-left [&[data-state=open]>svg]:tw-rotate-180",
          variant === "service" &&
            "tw-py-7 tw-text-lg md:tw-text-xl tw-font-normal",
          className,
        )}
        {...props}
      >
        {children}
        <ChevronDown className="tw-size-4 tw-shrink-0 tw-text-muted-foreground tw-transition-transform tw-duration-200" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  ),
);
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Content
      ref={ref}
      className="tw-overflow-hidden tw-text-sm data-[state=closed]:tw-animate-accordion-up data-[state=open]:tw-animate-accordion-down"
      {...props}
    >
      <div className={cn("tw-pb-4 tw-pt-0", className)}>{children}</div>
    </AccordionPrimitive.Content>
  ),
);
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
